// Route-tree assembly — the ONLY file that imports from all three group
// registration files. Sibling porters (core.tsx / agents.tsx / admin.tsx)
// never need to touch this file: it just nests each group's flat route
// array under the right parent and hands the result to main.tsx.
import { rootRoute } from './routes/__root';
import { authedRoute, adminRoute } from './routes/guards';
import { coreRoutes } from './routes/core';
import { agentsRoutes } from './routes/agents';
import { adminRoutes } from './routes/admin';

const authedRouteWithChildren = authedRoute.addChildren(agentsRoutes);
const adminRouteWithChildren = adminRoute.addChildren(adminRoutes);

export const routeTree = rootRoute.addChildren([
  ...coreRoutes,
  authedRouteWithChildren,
  adminRouteWithChildren,
]);
